import React from 'react';
import SplitLayout from '../../common/layouts/splitLayout/SplitLayout';
import FeeStructureForm from './FeeStructureForm';
import AdvanceSummaryCard from './advanceSummaryCard/AdvanceSummaryCard';
import styles from './styles/fee-structure-step.module.scss';

function FeeStructureStep({
    values,
    enabled,
    rules,
    handlers,
    panels,
    sideCard,
    loading,
    disabledSave,
    submitText,
    confirmBeforeSubmit,
    onSubmit,
    onCancel,
    readOnly,
}) {
    return (
        <SplitLayout
            className={styles.splitRoot}
            contentClassName={styles.splitContent}
            sideClassName={styles.splitSide}
            side={<AdvanceSummaryCard state={sideCard} />}
        >
            <FeeStructureForm
                values={values}
                enabled={enabled}
                rules={rules}
                handlers={handlers}
                panels={panels}
                loading={loading}
                disabledSave={disabledSave}
                submitText={submitText}
                confirmBeforeSubmit={confirmBeforeSubmit}
                onCancel={onCancel}
                onSubmit={onSubmit}
                readOnly={readOnly}
            />
        </SplitLayout>
    );
}

export default FeeStructureStep;
